<template>
    <div>
        <!-- Display props errors -->
        <div v-if='propsError'>
            <div v-for='error in errors' :key='error' class='text-danger'>{{ error }}</div>
        </div>


        <!-- If dont have eny error -->
        <div v-else>
            <div class="mt-3" style="display: block;">
                <h4>{{ bank.replace('_',' ') }}</h4>

                <label for="reservation_number">Reservation number</label>
                <input type="text" id="reservation_number" name="reservation_number" v-model='reservation_number' class="form-control">

                <label for="reservation_type">Reservation type</label>
                <input type="text" id="reservation_type" name="reservation_type" v-model='reservation_type' class="form-control">

                <button :disabled='disabled' class="btn btn-lg btn-primary btn-block mt-2 submitMonetawebReq" @click='submit'>Submit</button>
                <div :class="message.status" class="mt-3">
                    {{ message.message }}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FidoBorsellino',
  props: {
    bank: String,
    amount: String,
    token: String,
    operationa_unit: String,
    data: String,
    submitForm: Boolean,
    fidoReservationType: [String, Number]
    },
    data: function() {
      return {
      propsError:false,
      errors: [],
      reservation_number: '',
      reservation_type: '',
      message: '',
      disabled: false,
      clicked: false
  };
    },
    created(){
        // when clicked change value and excecute watch for clicked
        this.clicked = !this.clicked;

        this.reservation_type = this.fidoReservationType;

        // return error if is any error in prop
        if( !this.$props.amount ){
            this.errors.push('Amount prop is required')
            this.propsError = true
        }
        if( isNaN(this.$props.amount) ){
            this.errors.push('Amount prop need to be number in format 5.99 or 10')
            this.propsError = true
        }
        if( this.$props.amount.toString().split('.')[1] ){
            if( this.$props.amount.toString().split('.')[1].length > 2 ){
                this.errors.push('Amount prop need to be number in format 5.99 or 10')
                this.propsError = true
            }
        }
        if( this.$props.amount < 0.05 ) {
            this.errors.push('The amount must be at least 0.05.')
            this.propsError = true
        }
        if( !this.$props.operationa_unit ){
            this.errors.push('Operationa Unit is required')
            this.propsError = true
        }
        if( !this.$props.bank ){
            this.errors.push('Bank prop is required')
            this.propsError = true
        }
        if( !this.$props.token ){
            this.errors.push('Token missing')
            this.propsError = true
        }
        if( !this.$props.operationa_unit ){
            this.errors.push('Operationa unit is required')
            this.propsError = true
        }
    },
    methods: {
        submit: function() {
            if (!this.propsError) {
                var self = this
                this.disabled = true

                axios.post('https://gtn-gateway.draft2017.com/api/v2/orders',{
                    amount: this.$props.amount,
                    method: this.$props.bank.toLowerCase(),
                    reservation_number: this.reservation_number,
                    operationaUnit: this.$props.operationa_unit,
                    reservation_type: this.reservation_type
                },
                {
                    headers: {'Authorization': 'Bearer ' + this.$props.token}
                },
                )
                .then(response => (
                     response.data.success ? this.message = {'status': 'text-success','message':response.data.message} : this.message = {'status': 'text-danger','message':response.data.payload},
                     response.data.success ? this.reservation_number = '' : '',
                     this.disabled = false
                  )
                )
                .catch(function (error) {
                    // handle error
                    console.error(error.response)
                    self.errors.push(error.response.message)

                    // handle specific errors
                    if(error.response.data.errors.amount) {
                        self.errors.push(error.response.data.errors.amount[0])
                    }
                    if(error.response.data.errors.reservation_number) {
                        self.errors.push(error.response.data.errors.reservation_number[0])
                    }
                    if(error.response.data.errors.operationaUnit) {
                        self.errors.push(error.response.data.errors.operationaUnit[0])
                    }

                    self.propsError = true
                    self.disabled = false
                    // console.log(error.response.data.errors.amount[0]);
                });
            }
        }
    },
    watch: {
        clicked: function () {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {
                        // fill inputs
                        this.reservation_number = object.reservationNumber ? object.reservationNumber : '';

                        this.reservation_type = this.fidoReservationType;

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        // if( object.autoSubmit ) {
                        //     if (this.$props.submitForm) {
                        //         this.submit();
                        //     }
                        // }
                    }
                }
            }
        },
        submitForm: function (value) {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        if( object.autoSubmit ) {
                            if (value) {
                                this.submit();
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
